var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#092E20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.689 51H141.304V183.45C126.625 186.237 115.848 187.352 104.143 187.352C69.2093 187.351 51 171.559 51 141.271C51 112.098 70.3253 93.1471 100.24 93.1471C104.885 93.1471 108.415 93.5175 112.689 94.6323V51ZM112.689 117.671C109.345 116.558 106.558 116.186 103.028 116.186C88.5346 116.186 80.1725 125.105 80.1725 140.712C80.1725 155.95 88.163 164.311 102.842 164.311C105.999 164.311 108.602 164.125 112.689 163.569V117.671Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.826 95.1893V161.522C186.826 184.378 185.154 195.34 180.137 204.817C175.491 213.923 169.359 219.682 156.724 226L130.153 213.364C142.788 207.419 148.92 202.218 152.821 194.225C156.91 186.05 158.212 176.573 158.212 151.675V95.1893H186.826ZM158.212 51.1519H186.826V80.5102H158.212V51.1519Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.126ddbed662f18d4e059204da06e2af2.svg";
export { ForwardRef as ReactComponent };